module.exports = __webpack_public_path__ + "img/Hvit NC 2023 Dag 3 Gr-Kbr-Skrim-Gr.b6a473b9.png";